import api from "src/api/axios";

export const getDriverGpsLocation = async (params) => {
  const response = await api.get(
    `/gps/driver-locations${params ? `?${params}` : ""}`
  );
  return response;
};

export const getDriverGpsHistory = async (params) => {
  const response = await api.get(
    `/gps/v1/driver-locations-history${params ? `?${params}` : ""}`
  );
  return response;
};

export const getDeviceList = async (country_id, device_d) => {
  let query = "";
  if(country_id) {
    query += `&country_id=${country_id}`;
  }
  if(device_d) {
    query += `&device_id=${device_d}`;
  }
  const res = await api.get(`/devices?${query}`);
  return res.data;
};

export const getDeviceHistoryById = async (deviceId, ts1, ts2) => {
  const res = await api.get(`/gps/driver-locations-history/${deviceId}?startTime=${ts1}&endTime=${ts2}`);
  return res.data;
};